/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { Component } from "react";

class BackButton extends Component {
  handleClick = () => {
    // If in single layout, switch back to grid
    if (this.props.layout === 'single') {
      this.props.toggleGalleryLayout('grid');
    } else {
      // If in grid layout, navigate back to category
      this.props.categoryChangeHandler(this.props.category);
    }
  }

  render() {
    return (
      <div
        className="icon-wrapper"
        onClick={this.handleClick}
      >
        <img
          src={require("../assets/images/back-nav.svg")}
          alt="previous"
          className="index-arrow"
        />
        <span>Back</span>
      </div>
    );
  }
}

export default BackButton;
